<template>
  <div class="main-layout">
    <AppHeaderNav />
    <main class="main-body">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import AppHeaderNav from '../components/AppHeaderNav.vue'
</script>

<style scoped>
.main-layout {
  /* 与 AppHeaderNav 固定高度 56px 一致，避免主内容被遮挡 */
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 56px;
  background: #f0f2f5;
}

.main-body {
  min-height: 0;
}
</style>
